import useVisible from "../../hooks/useVisible.jsx";
import handleClick from "../../utils/handleClick.js";

function IllustratorConvertToShape({
  selectedTag,
  buttonTags,
  generateButtonTags,
}) {
  const [isVisible, setIsVisible] = useVisible("ConvertToShapeVisibility");
  const [deleteLayer, setDeleteLayer] = useVisible("deleteLayer");

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-sharp fa-regular fa-object-subtract"></i>
        </div>
        <div className="button-card__title">Illustrator Convert to Shape</div>
        {generateButtonTags()}
      </li>
      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        <div className="render-group__checkbox-group">
          <div className="render-group__checkbox">
            <input
              type="checkbox"
              id="delete-layer-shape"
              checked={deleteLayer}
              onChange={() => setDeleteLayer(!deleteLayer)}
              className="hidden-checkbox"
            />
            <label htmlFor="delete-layer-shape">
              <span className="custom-checkbox"></span>
              <span className="label-text">Delete Layer</span>
            </label>
          </div>
        </div>

        <div className="videobolt-tools">
          <div
            onClick={() =>
              handleClick("illustratorConvertToShape", {
                type: "layer",
                deleteLayer: deleteLayer,
              })
            }
            className="resolution-tools__button"
          >
            <i class="fa-light fa-layer-group"></i>
            <span>Selected Layers</span>
          </div>
          <div
            onClick={() =>
              handleClick("illustratorConvertToShape", {
                type: "comp",
                deleteLayer: deleteLayer,
              })
            }
            className="resolution-tools__button"
          >
            <i class="fa-solid fa-image-polaroid"></i>
            <span>Active Comp</span>
          </div>
          <div
            onClick={() =>
              handleClick("illustratorConvertToShape", {
                type: "selected comp",
                deleteLayer: deleteLayer,
              })
            }
            className="resolution-tools__button"
          >
            <i class="fa-solid fa-images"></i>
            <span>Selected Comp</span>
          </div>
          <div
            onClick={() =>
              handleClick("illustratorConvertToShape", {
                type: "project",
                deleteLayer: deleteLayer,
              })
            }
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-photo-film"></i>
            <span>Project</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default IllustratorConvertToShape;
